import type { FC } from 'react'
import styled from '@emotion/styled'

import type { Option } from '@segment/matcha/components/Menu/useMenu'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { useFiltersQuery } from '@segment/api/routes/resources/queries'

import FilterSelect from './FilterSelect'

interface FiltersProps {
  onFilterChange?: (filterId: string, selectedOptions: Option[]) => void
}

const Filters: FC<FiltersProps> = ({ onFilterChange = () => null }) => {
  const { data: filters } = useFiltersQuery({ args: [] })
  return (
    <StyledSectionBase variant="centered">
      <Section.Contents>
        <StyledColumnTrack gap="small" columns={1} overrides={{ lg: filters?.length }}>
          {filters?.map(({ id, displayName, searchableId, options }) => (
            <FilterSelect
              key={id}
              id={id}
              placeholder={displayName}
              options={options}
              onSelect={(selectedOptions) => onFilterChange(searchableId, selectedOptions)}
            />
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;

  ${Section.Wrapper} {
    margin: auto;
    justify-content: unset;
    padding-top: 24px;
    padding-bottom: 32px;
    row-gap: 0;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 40px;
    }
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 520px;
  row-gap: 8px;
  margin: 0 auto;
  margin-bottom: 8px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 704px;
  }

  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding: 0 80px;
  }
`

export default Filters
